import classNames from "classnames";
import { FC, ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as ArrowSVG } from "assets/images/common/arrow.svg";
import { ReactComponent as LogoIcon } from "assets/images/common/logo.svg";
import { ReactComponent as LogoutSVG } from "assets/images/menu/logout.svg";

import adminAvatar from "assets/images/admin.png";
import Button from "components/Button";
import { useGuardedNavigation } from "hooks/useGuardedNavigation";
import { useAppDispatch } from "store/hooks";
import { logoutRequest } from "store/slices/authSlice";

type PropTypes = {
  isBackButton?: boolean;
  backButtonLink?: string;
  title?: string;
  description?: ReactElement | string;
  actions?: React.ReactNode;
};

const Header: FC<PropTypes> = ({ isBackButton, backButtonLink, title, description, actions }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const guardNavigation = useGuardedNavigation();

  const handleBackButton = () => {
    guardNavigation(() => {
      if (backButtonLink) {
        navigate(backButtonLink);
      } else {
        navigate(-1);
      }
    });
  };

  const handleLogout = () => {
    guardNavigation(() => dispatch(logoutRequest()));
  };

  return (
    <header className="header">
      <div className="header__top">
        <span className="header__top-logo">
          <LogoIcon />
        </span>

        <div className="header__top-user">
          <img
            className="header__top-user-avatar"
            src={adminAvatar}
            alt="user"
          />

          <Button form="circle" variant="white" onClick={handleLogout}>
            <LogoutSVG />
          </Button>
        </div>
      </div>

      <div className={classNames("header__bottom", { "header__bottom--detail": isBackButton })}>
        <div className="header__info">
          {isBackButton && (
            <Button form="circle" variant="white" onClick={handleBackButton}>
              <ArrowSVG />
            </Button>
          )}

          <div className="header__content">
            <h1 className="header__title">{title}</h1>

            {!!description && <p className="header__description">{description}</p>}
          </div>
        </div>

        {!!actions && <div className="header__actions">{actions}</div>}
      </div>
    </header>
  );
};

export default Header;
